<!--
 * @Description: 专精特新H5-小巨人测评页
 * @Author: yeqing
 * @Date: 2021-12-15 11:30:30
 * @LastEditTime: 2021-12-21 17:09:27
 * @LastEditors: yeqing
-->
<template>
  <div class="little-h5">
    <div class="menu-title-box">
      <div :class="tabKey == 1 ? 'active' : 'pass'">企业基本信息</div>
      <div :class="tabKey == 2 ? 'active' : tabKey > 2 ? 'pass' : ''">创新能力</div>
      <div :class="tabKey == 3 ? 'active' : tabKey > 3 ? 'pass' : ''">经济效益</div>
      <div :class="tabKey == 4 ? 'active' : tabKey > 4 ? 'pass' : ''">获取报告</div>
    </div>
    <div class="lit-txt1">温馨提示：为保证结果的准确性，请如实填写</div>
    <div class="lit-cont">
      <first-step v-show="tabKey == 1" ref="firstStep" @onBlur="hideshow = true" @onFocus="hideshow = false" />
      <second-step v-show="tabKey == 2" ref="secondStep" @onBlur="hideshow = true" @onFocus="hideshow = false" />
      <third-step v-show="tabKey == 3" ref="thirdStep" />
    </div>
    <!-- 底部 -->
    <div class="lit-foot" :style="styleObj">
      <van-button plain type="info" style="margin-right: 0.2rem" @click="previouStep">上一步</van-button>
      <van-button type="info" v-show="tabKey != 3" @click="nextStep">下一步</van-button>
      <van-button type="info" @click="onSubmit" v-show="tabKey == 3">获取报告</van-button>
    </div>
  </div>
</template>
<script>
import FirstStep from './component/firstStep.vue'
import SecondStep from './component/secondStep.vue'
import ThirdStep from './component/thirdStep.vue'
import { littleGiantEva, } from '@/api/enterpriseSpecial'
import '../index.less'
import {setHeight} from "@/utils/zgzx";
export default {
  data() {
    return {
      tabKey: '1',
      hideshow: true, //显示或者隐藏底部按钮
    }
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
  },
  created() {
    document.title = '专精特新小巨人测评'
    setTimeout(() => {
      setHeight();
    }, 1000)
  },
  methods: {
    // 是否有空值
    isEmpty(data) {
      let falg = true
      for (const key in data) {
        const element = data[key]
        if (!element && element !== 0) {
          falg = false
        }
      }
      if (!falg) {
        this.$notify('您有未填写的企业信息，请补全完成')
      }
      return falg
    },
    // 下一步
    nextStep() {
      if ((this.tabKey == 1 && !this.isEmpty(this.$refs.firstStep.giantForm)) || (this.tabKey == 2 && !this.isEmpty(this.$refs.secondStep.giantForm))) {
        return
      }
      this.tabKey++
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.scrollTo(0, 0)
    },
    // 上一步
    previouStep() {
      if (this.tabKey == '1') {
        this.$router.push('/enterpriseSpecialH5')
      } else {
        this.tabKey--
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.scrollTo(0, 0)
      }
    },
    // 获取报告
    onSubmit() {
      if (!this.isEmpty(this.$refs.thirdStep.giantForm)) {
        return
      }
      // 处理传参
      let info = {
        ...this.$refs.firstStep.giantForm,
        ...this.$refs.secondStep.giantForm,
        ...this.$refs.thirdStep.giantForm,
      }
      let data = []
      for (const key in info) {
        let soure = key.substr(1)
        soure = soure.slice(0, 1) + '-' + soure.slice(1)
        soure = soure.slice(0, 3) + '-' + soure.slice(3)
        data.push({
          code: soure,
          content: info[key],
        })
      }
      this.loading = true
      littleGiantEva(data)
        .then((res) => {
          sessionStorage.setItem('resultData', JSON.stringify(res.data))
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          window.scrollTo(0, 0)
          // 判断是否登录
          const uid = sessionStorage.getItem('uid')
          this.loading = false
          if (uid === '0' || !uid) {
            sessionStorage.setItem('loginFrom', 'littleGiant') // 从小巨人跳转到登录
            this.$router.push('/enterpriseSpecialH5/login')
            return
          }
          this.$router.push('/enterpriseSpecialH5/littleGiant/result')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  computed: {
    styleObj() {
      if (!this.hideshow) {
        return {
          position: 'static',
          left: '0',
          transform: 'translateX(0)',
        }
      }
      return {
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
      }
    },
  },
}
</script>
